import { styled, css } from '@mui/material/styles';
import React from 'react';

import { UseViewSwitcherOptions, ViewType } from './types';
import { useViewSwitcher } from './use-view-switcher';

export interface ViewSwitcherContainerProps extends UseViewSwitcherOptions {
  children: (view: ViewType) => React.ReactNode;
  className?: string;
}

const ViewSwitcherContainerImpl: React.FC<ViewSwitcherContainerProps> = ({
  children,
  className,
  ...options
}) => {
  const { view } = useViewSwitcher(options);

  return <div className={className}>{children(view)}</div>;
};

export const ViewSwitcherContainer = styled(ViewSwitcherContainerImpl)(
  ({ theme }) => css`
    /* Add any custom styling if needed */
  `
);
